module.exports = __webpack_public_path__ + "media/images/emoticons/empty-7122614bc7c8f8600e1c3e0714097322.gif";